import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { ExcelExportService } from 'src/app/Services/excel.service';
import { StorageService } from 'src/app/Services/storage.service';


@Component({
  selector: 'g10-route-booking-reports',
  templateUrl: './route-booking-reports.component.html',
  styleUrls: ['./route-booking-reports.component.css']
})
export class RouteBookingReportsComponent implements OnInit {


  @Input() _activeMenu: string = '';
  @Output() routeTypeEmit = new EventEmitter();
  pageNum = 1;
  public routeType = '';
  public routeInfo: any = {};
  public routeData: any = [


    //  {

    //         "route": "Pallikaranai",
    //         "noOfvehicle": "9",

    //         "date": "12-3-2022",
    //         "totalSeat": "5",
    //         "filledSeat": "5",
    //       },
    //      {

    //         "route": "Pallikaranai",
    //         "noOfvehicle": "7",

    //         "date":" 12-3-2022",
    //         "totalSeat": "5",
    //         "filledSeat": "3",
    //       },

    //      {

    //         "route": "Pallikaranai",
    //         "noOfvehicle": "14",

    //         "date": "12-3-2022",
    //         "totalSeat": "7",
    //         "filledSeat": "5",
    //       },
    //   {

    //         "route": "Pallikaranai",
    //         "noOfvehicle": "12",

    //         "date": "12-3-2022",
    //         "totalSeat": "20",
    //         "filledSeat": "8",
    //       },
  ]

  /* Pagination */
  public userPaginationData:any;
  public showPagination: boolean = true;
  public paginationData = {
    page: 1,
    limit: 10,
    totalPage: 1,
  };

  public noDataFoundEnable: boolean = false;
  public showTable: boolean = false;
  public routeTableData: any = [];
  public tableData: any = [];
  public cols: any = [
    { key: '#', display: '#' },
    { key: 'name', display: 'Route name' },
    { key: 'noOfVehicle', display: 'Number of vehicle',headerConfig:{ isDefault: true}},
    {
      key: 'tripDate', display: 'Date', config: {
        isDate: true,
        format: 'dd/MM/YYYY'
      },
      headerConfig:{ isDefault: true}
    },
    { key: 'filledSeat', display: 'Number of booking' , headerConfig:{ isDefault: true}},
  ];

  public matFormSize = '12px';
  public filterForm: FormGroup;
  public errorObject: any = {
    startDate: '',
    endDate: '',
  }
  public maxDate = new Date(new Date().setHours(24));
  public maxEndDate = new Date(new Date().setHours(24));
  public defaultMaxDate = new Date(new Date().setHours(24));
  public formSubmitted: boolean = false;
  public excelData: any = {};
  public showDownloadBtn: boolean = false;
  public exlNoDataFound: boolean = false;
  public routeExlData: any = [];
  public routeDetails: any = {};

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private api: ApiService,
    private storage:StorageService,
    private com: CommonServices,
    public fb: FormBuilder,
    public excel: ExcelExportService,
    private dateAdapter: DateAdapter<Date>
  ) {
    this.dateAdapter.setLocale('en-GB'); //dd/MM/yyyy
    this.userPaginationData = this.storage.get('pagination') ? this.storage.get('pagination') : null;
  }
  ngOnInit(): void {
    this.getBookingDayConfigData();
    this.filterFormLoad();
    if(this.userPaginationData!=undefined && this.userPaginationData['tpmRouteBookReport']){
      this.routeBookingReports(this.userPaginationData['tpmRouteBookReport']['page'], this.userPaginationData['tpmRouteBookReport']['limit']);
    }
    else {
      setTimeout(()=>{ this.routeBookingReports(); },1000);
    }
  }
  getBookingDayConfigData() {
    this.api.transportManagerGblSetBookingDayConfigList({}).then((res: any) => {
      if (res && res.status == 'success') {
        if(res.data && res.data[0]){
          let dayCount = res.data[0] && res.data[0].dayCount ? res.data[0].dayCount : 1;
          this.setDateMax(dayCount)
        }
      }
    }).catch((err) => {
      console.log('error', err);
    })
  }

  setDateMax(days){
    // let noOfHours = 24 * (+days);
    // this.maxDate = new Date(new Date().setHours(noOfHours));
    // this.maxEndDate = new Date(new Date().setHours(noOfHours));
    // this.defaultMaxDate = new Date(new Date().setHours(noOfHours));

    let currentMonthDays=new Date(new Date().getFullYear(), new Date().getMonth()+1, 0).getDate();
    let day=new Date().getDate();
    let balanceDaysInThisMonth=currentMonthDays-day;
    var d = new Date();
    let dt = new Date(d.setMonth(d.getMonth() + 1));
    let nextMonthDays=new Date(new Date(dt).getFullYear(), new Date(dt).getMonth()+1, 0).getDate();
    let totalDays=balanceDaysInThisMonth+nextMonthDays;
    var lastDate = new Date();
    lastDate.setDate(lastDate.getDate()+totalDays);
    this.maxDate = lastDate;
    this.maxEndDate = lastDate;
    this.defaultMaxDate = lastDate;
  }
  getRouteINfo(data, resObj, pageObj) {
    if (data) {
      this.routeData = data;
      // this.routeInfo = {};
      let routeIDs: any = [];
      let ids = '';
      if (Object.keys(data).length > 0) {
        Object.keys(data).map((ts) => {
          Object.keys(data[ts]).map((route) => {
            routeIDs.push(route);
          })
        })

        ids = Array.from(new Set(routeIDs)).join(',');

        let obj = {
          routeIDs: ids
        }

        this.api.selectedRoutes(obj).then(async (res: any) => {
          if (res && res['status'] == 'success') {
            if (res['data'].length > 0) {
              res['data'].map((route) => {
                this.routeInfo[route['routeID']] = route;
              });
            }
            this.processTableData();
            // this.processPagination(resObj,pageObj);        /* remove comments when pagination requires*/
          }
          else {
            this.noDataFoundEnable = true;
            this.showTable = true;
            this.routeTableData = [];
            this.tableData = [];
          }
        });
      } else {
        this.tableData = [];
        this.routeTableData = [];
        this.showTable = true;
        this.noDataFoundEnable = true;
      }
    }
  }

  routeBookingReports(page?, limit?, filters?) {
    let obj = {};

    // if (page) obj['page'] = page;
    // if (limit) obj['limit'] = limit;
    if (filters) obj = { ...obj, ...filters };


    this.api.getRouteBookingReports(obj).then(async (res: any) => {
      if (res && res['status'] == 'success') {
        this.routeData = await this.processRouteAPIData(res['data']);
        this.getRouteINfo(this.routeData, res, obj);
      }
    })
  }

  processRouteAPIData(apiData) {
    return new Promise((resolve, reject) => {
      try {
        let resObj: any = {};
        if (apiData.length > 0) {
          apiData.map((data: any) => {
            try {
              let tripData: any = data['tripDate'];
              let tripTS: any = tripData['tripDate'];
              let routeID: any = tripData['routeID'];
              if (tripTS != undefined && routeID != undefined) {
                if (resObj[tripTS] == undefined) resObj[tripTS] = {};
                if (resObj[tripTS][routeID] == undefined) resObj[tripTS][routeID] = [];
                resObj[tripTS][routeID].push(tripData);
              }
            } catch (err) {
              console.log(err);
            }
          });
          resolve(resObj)
        }
        else resolve({});
      } catch (err) {
        console.log(err);
        reject({})
      }
    })
  }


  async processTableData() {
    this.showTable = false;
    this.tableData = [];
    this.routeTableData = [];
    this.noDataFoundEnable = false;
    /* if(this.routeData.length>0){
      this.routeData.map((data:any)=>{
      try{

        let tripData:any = data['tripDate'];
        let obj = {
          name: this.routeInfo[tripData.routeID]['title'],
          noOfVehicle: this.routeInfo[tripData.routeID]['vehicle'] ? this.routeInfo[tripData.routeID]['vehicle'].length : 0,
          tripDate: tripData.tripDate,
          filledSeat: this.routeData[ts][route].length,
          routeID: tripData.routeID,
        };
        this.tableData.push(obj);

      }
      catch(err:any){ console.log(err); }
      })
    } */

    try {
      this.routeTableData = await this.processRouteArrayVal(this.routeData);
      this.processPaginationData(this.paginationData);
      // this.tableData = [...this.routeTableData];
    } catch (err) {
      console.log(err)
    };
    setTimeout(() => { this.showTable = true; this.noDataFoundEnable = true; }, 100);
  }

  processPagination(data, req) {
    this.showTable = false;
    this.paginationData = {
      page: req.page,
      limit: req.limit,
      totalPage: this.getTotalCount(data.totCnt, req.limit),
    }
    this.storage.setData({pagination: { ...this.userPaginationData,'tpmRouteBookReport':this.paginationData } });
    this.showTable = true;
  }

  getTotalCount(total, limit) {
    let result: any = 1;
    if (total / limit > 0) {
      result = total / limit;
      if (total % limit > 0) result++;
    }
    return Math.floor(result);
  }

  pagination(data) {
    // this.routeBookingReports(data.page,data.limit);  // (data.page,data.limit,'search') use third parameter to get results for search inputs
    this.processPaginationData(data);
  }

  processPaginationData(pageObj?) {
    if (this.routeTableData.length > 0) {
      try {
        let obj = {
          page: pageObj && pageObj.page ? pageObj.page : 1,
          limit: pageObj && pageObj.limit ? pageObj.limit : 5,
        };
        let pageNo = obj.page;
        let limit = obj.limit;
        let startIndex = (pageNo - 1) * limit;
        this.tableData = this.routeTableData.slice(startIndex, pageNo * limit);
        this.processPagination({ totCnt: this.routeTableData.length, }, obj);
      } catch (err) {
        this.noDataFoundEnable = true;
        this.showTable = true;
        this.tableData = [];
        console.log('err', err);
      }
    } else {
      this.noDataFoundEnable = true;
      this.showTable = true;
      this.tableData = [];
      this.routeTableData = [];
    }
  }



  pageNavigate(path, $event) {


    const urlPath = 'organization/transport-manager/reports/';
    this.router.navigate([urlPath + 're-route']);
    setTimeout(() => {
      this.router.navigate([urlPath + path]);
    }, 10);
    // this.router.navigate(['/heroes', { id: heroId }]);
  }

  filterFormLoad() {
    this.filterForm = this.fb.group({
      // vehicle: new FormControl('', [Validators.required]),
      search: new FormControl(''),
      startDate: new FormControl('', [Validators.required]),
      endDate: new FormControl('', [Validators.required]),
    });
  }

  dateFromAction(obj: any = {}, type) {
    obj.selectedDates.map((x: any) => {
      this.filterForm.controls[type].patchValue(x.getTime());
    });
  }

  setMaxDate() {
    let t_maxDate = new Date(this.filterForm.controls.startDate.value);

    //add a day to the date
    t_maxDate.setDate(t_maxDate.getDate() + 30);

    if (this.defaultMaxDate > t_maxDate) {
      this.maxEndDate = t_maxDate;
    }else{
      this.maxEndDate = this.defaultMaxDate;
    }

  }

  validation(data) {
    let objectKeys = Object.keys(this.errorObject);
    let isValid = true;
    for (let i = 0; i < objectKeys.length; i++) {
      let key = objectKeys[i];
      this.errorObject[key] = '';
      if (data[key] == '' || data[key] == undefined || data[key] == null || Number.isNaN(data[key]) || data.length <= 0) {
        this.errorObject[key] = key.split(/(?=[A-Z])/).join(" ").toLowerCase() + ' is required.';
        isValid = false;
      } else if ((key == 'startDate' || key == 'endDate')) {
        if (new Date(data.startDate).getTime() > new Date(data.endDate).getTime()) {
          isValid = false;
          this.errorObject['endDate'] = 'Invalid end date';
        }
      }
    }
    return isValid;
  }

  checkValidation() {
    let obj = {
      startDate: new Date(this.filterForm.value.startDate).getTime(),
      endDate: new Date(this.filterForm.value.endDate).getTime(),
    }
    if (this.formSubmitted) this.validation(obj);
  }

  onSubmit() {
    this.formSubmitted = true;
    let checkObj = {
      startDate: new Date(this.filterForm.value.startDate).getTime(),
      endDate: new Date(this.filterForm.value.endDate).getTime(),
    }
    let isValid = this.validation(checkObj);
    if (isValid) {
      let obj = {
        startDate: new Date(new Date(this.filterForm.value.startDate).setHours(0)).getTime(),
        endDate: new Date(new Date(this.filterForm.value.endDate).setHours(23, 59, 59)).getTime(),
      }
      if (this.filterForm.value.search != '') obj['search'] = this.filterForm.value.search;
      this.routeBookingReports(false, false, obj);
      this.getRouteExlReports(obj);
    }
  }

  getRouteExlReports(obj) {
    this.showDownloadBtn = false;
    this.routeExlData = [];
    this.api.getRouteBookingExlReports(obj).then(async (res: any) => {
      if (res && res.data && res.data.length > 0) {
        // let routeRestults = await this.processRouteData(res.data);
        // if(this.routeInfo && Array.isArray(routeRestults) && routeRestults.length>0){
        //   routeRestults.map((item)=>{
        //     if(item.routeID){
        //       this.routeInfo[item.routeID] = item;
        //     }
        //   })
        // }
        let resRouteData = await this.processRouteAPIData(res.data);
        this.routeExlData = await this.processRouteArrayVal(resRouteData);
        this.exportToExcel();
      } else {
        this.exlNoDataFound = true;
      }
    }).catch((err) => { console.log(err); this.exlNoDataFound = true; })
  }

  processRouteArrayVal(data) {
    return new Promise((resolve, reject) => {
      try {
        let arrOfData: any = [];
        let timeStamps = Object.keys(data).sort((a, b) => Number(b) - Number(a));

        timeStamps.map((ts) => {

          Object.keys(data[ts]).map((route: any) => {
            if (this.routeInfo[route]) {
              let obj = {
                name: this.routeInfo[route]['title'],
                noOfVehicle: this.routeInfo[route]['vehicle'] ? this.routeInfo[route]['vehicle'].length : 0,
                tripDate: ts,
                filledSeat: data[ts][route].length,
                // seatCap: route.seatCap,
                routeID: data[ts][route][0]['routeID'],
              };
              arrOfData.push(obj);
            }
          })

          resolve(arrOfData)
        })
      } catch (err) {
        console.log(err);
        reject([]);
      };
    })
  }

  async processRouteData(data) {

    return new Promise(async (resolve, reject) => {
      try {
        if (data && data.length > 0) {
          let routeID: any = data.map(itm => itm.routeID);
          let routeIDs = Array.from(new Set(routeID)).join(',');
          let routeData = [];
          if (routeID.length > 100) {
            let obj = { routeIDs };
            let ping = 1, i = 0;
            while (ping) {
              obj['page'] = i + 1;
              i++;
              let results = await this.api.selectedRoutes(obj).catch((e) => { console.log('Route Data retriving issues') });
              if (results && results['status'] == 'success') {
                if (results['data'].length <= 0) ping = 0;
                else routeData.push(results['data']);
              }
              else ping = 0;

            }
          }
          else {
            let results = await this.api.selectedRoutes({ routeIDs }).catch((e) => { console.log('Route Data retriving issues') });
            if (results && results['status'] == 'success') {
              routeData = results['data'];
            }
          }
          resolve(routeData);
        }
        else resolve([]);
      } catch (error) {
        reject(error);
      }
    });

  }

  async exportToExcel() {
    let data = [];

    const startDate = new Date(this.filterForm.value.startDate + '');
    const endDate = new Date(new Date(this.filterForm.value.endDate + '').setHours(23, 59, 59));

    for (let i = 0; i < this.routeExlData.length; i++) {
      let item = this.routeExlData[i];
      console.log(item);
      try {
        let res = {
          value: [
            i + 1,
            item.routeID && this.routeInfo[item.routeID] && this.routeInfo[item.routeID]['title'] ? this.com.convertTitleCase(this.routeInfo[item.routeID]['title']) : '---',
            item.noOfVehicle,
            item.tripDate ? this.com.timestampToDate(+item.tripDate, 'DMY') : '--/--/----',
            (item.filledSeat || item.filledSeat == 0) ? item.filledSeat : '--',
          ],
          alignment: [
            { cell: `A${i + 6}`, value: { vertical: 'top', horizontal: 'right' } },
            { cell: `F${i + 6}`, value: { vertical: 'top', horizontal: 'right' } }
          ]
        };
        data.push(res);

      } catch (err) {
        console.log(err);
      }
    }
    if (data.length > 0) {

      let customizedData = [];

      let titleRow = {
        value: ['Route Booking Report'],
        mergeCells: ["A1:E2"],
        font: {
          name: 'Corbel', family: 4, size: 16, bold: true,
          color: { argb: 'FFFFFFFF' },
        },
        alignment: {
          cell: "A1", value: { vertical: 'middle', horizontal: 'center' },
        },
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '966462AF' },
          bgColor: { argb: '966462AF' }
        },
      }

      customizedData.push(titleRow);

      let subtitleRow = {
        value: ["Start Date  : " + this.com.timestampToDate(new Date(startDate).getTime(), 'DMY') + "\n" +
          "End Date    : " + this.com.timestampToDate(new Date(endDate).getTime(), 'DMY')],
        font: { name: 'Corbel', family: 4, size: 12, },
        mergeCells: ["A3:E4"],
      }

      customizedData.push(subtitleRow);

      let headerRow =
      {
        value: ['S No', 'Route name', 'Number of vehicle', 'Date', 'Seat count'],
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFFFFF00' },
          bgColor: { argb: 'FF0000FF' }
        },
        font: { bold: true },
        border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      }
      customizedData.push(headerRow);

      customizedData = [...customizedData, ...data];

      const excelInfo = {
        customizedData: customizedData,
        data: {
          columWith: [{ colNo: 2, width: 25 }, { colNo: 3, width: 20 }, { colNo: 4, width: 15 }, { colNo: 5, width: 15 }]
        }
      };

      if (this.excelData['Route_Booking_Report'] == undefined) { this.excelData['Route_Booking_Report'] = {}; }

      this.excelData['Route_Booking_Report'] = excelInfo;
      this.exlNoDataFound = false;
      this.showDownloadBtn = true;
    }
    else this.exlNoDataFound = true;

  }

  downloadExlReport() {
    this.excel.generateExcel(this.excelData, 'Route_Booking_Report' +this.com.timestampToDate(new Date().getTime(),'DMY' )  + '.xlsx');
  }
}
